import { render, staticRenderFns } from "./VTTab.vue?vue&type=template&id=01f1aa98&"
import script from "./VTTab.vue?vue&type=script&lang=js&"
export * from "./VTTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports